import { ServiceMode } from 'state/service-mode/types';

import { CATERING_SERVICE_MODES, DELIVERY_SERVICE_MODES } from './service-mode';

export enum ServiceModeCategory {
  CATERING = 'CATERING',
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
}

/**
 * @name determineServiceModeCategory
 * @description gives a category to the provided SM
 *     need this bc pickup & catering have multiple
 *     SM values that fall into one of the categories
 */
export const determineServiceModeCategory = (serviceMode: ServiceMode) => {
  let smType = ServiceModeCategory.PICKUP;
  if (DELIVERY_SERVICE_MODES.includes(serviceMode)) {
    smType = ServiceModeCategory.DELIVERY;
  }
  if (CATERING_SERVICE_MODES.includes(serviceMode)) {
    smType = ServiceModeCategory.CATERING;
  }
  return smType;
};
